const messages = {
    en: {
      searchForQusestion: "Search for question",
      searchByKeyword: "Search by keyword",
      searchByTypeAhead: "Search by typeahead",
      searchById: "Search by id",
      keyword: "Keyword",
      search: "Search",
      clearVal: "Clear form",
      searchSuccess: "Success",
      searchError: "Error"
    },
    ru: {
      searchForQusestion: "Поиск вопроса",
      searchByKeyword: "Поиск по ключевым словам",
      searchByTypeAhead: "Поиск по typeahead",
      searchById: "Поиск по ID",
      keyword: "Kлючевое слово",
      search: "Поиск",
      clearVal: "Oчисть формy",
      searchSuccess: "Success",
      searchError: "Error"
    }
  };

  export default messages;